module.exports = __webpack_public_path__ + "font/fontello.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/font/fontello.svg
// module id = 46
// module chunks = 0